import React from 'react';
import { connect } from 'react-redux';
import { openModal, hideModal } from 'cards/actions/modalActions';
import { getCardSettings } from 'cards/util/cardSettingsUtils';
import {
  getMostPopularAvailableSamplesFromFamily,
  useSingleSampleLimitExhausted,
  useModalCloseCallback,
} from '../util/hooks';
import FeatureFlags from '../../../../../util/featureFlags';
import styles from './styles.module.less';

const SingleSampleAccessPoint = ({ familyName, showModal, closeModal, displayComponent }) => {
  if (!familyName) {
    return null;
  }
  const cardInfo = getMostPopularAvailableSamplesFromFamily(familyName);
  const {
    uuid,
    cardType,
    isMagnet,
    isLetterpress,
    singleSampleAvailable,
    singleSampleSku,
    sampleCard,
  } = cardInfo;
  const [sampleLimitExhausted, fetchSampleLimitExhausted] = useSingleSampleLimitExhausted(cardType);

  const preventClose = FeatureFlags.get('invitesSinglesampleSaveToDraftsOnExit');
  const closeCallback = useModalCloseCallback();

  const originalModalOptions = {
    warnOnClose: !preventClose,
    preventClose,
    closeCallback,
  };

  function handleOpenModal(overrideProps = {}) {
    showModal(
      {
        entryPoint: 'WEBSITE',
        card: sampleCard.lead_card,
        cardSuiteUUID: uuid,
        isMagnet,
        isLetterpress,
        sampleLimitExhausted,
        fetchSampleLimitExhausted,
        handleOpenModal,
        initialCloseCallback: closeCallback,
        closeModal,
        originalModalOptions,
        nonEditableSingleSampleSku: singleSampleSku,
        ...overrideProps,
      },
      originalModalOptions
    );
  }

  if (!cardInfo.singleSampleAvailable) {
    return null;
  }
  return (
    <>
      {React.cloneElement(displayComponent, {
        handleOpenModal,
        cardTypeLabel: getCardSettings(cardType).label,
        singleSampleAvailable,
      })}
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  showModal: (props, overrideOptions = {}) =>
    dispatch(
      openModal('SINGLE_SAMPLE_MODAL', props, {
        warnOnClose: true,
        bottomModalOnMobile: true,
        className: styles.modal,
        ...overrideOptions,
      })
    ),
  closeModal: () => dispatch(hideModal()),
});

const mapStateToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SingleSampleAccessPoint);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleAccessPoint/SingleSampleAccessPoint.jsx